import type { Options } from '#netzo/shared/types/core'
import type { File, Option } from '#netzo/shared/types/db'
import { createId } from '#netzo/utils/core/db'
import { merge } from 'es-toolkit/compat'

export const getDefaultAccountgroup = (data: Partial<Accountgroup>) => {
  return merge({
    id: createId(), // IMPORTANT: cloudflare throws error if called on global scope
    tags: [],
    data: getDefaultAccountgroupData(data?.data ?? {}),
  }, data)
}

export const getAccountgroupInformation = (data: Partial<Accountgroup>) => {
  if (!data) return []
  return [
    ['Nombre', data?.name],
    ['Descripción', data?.description],
  ].map(([key, value]) => [key, value || '-'])
}

export const optionsAccountgroups = {} satisfies Options

export const optionsAccountgroupsMap = {}

export const relationsAccountgroups: Record<string, boolean> = {
  accounts: true,
  user: true,
  files: true,
  // options: true,
}

export type AccountgroupWithRelations = Accountgroup & {
  accounts: Account[]
  user: User[]
  files: File[]
  options: Option[]
}

export const viewSettingsAccountgroups: ViewSettings = {
  tableName: 'accountgroups',
  typeOptions: optionsShared.views.filter(view => ['grid', 'gallery'].includes(view.value)),
  type: 'gallery',
  pagination: { page: 1, pageSize: 25 },
  paginationOptions: optionsShared.page,
  compact: false,
  columns: [
    {
      key: 'select',
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'actions',
      disabled: true,
      class: 'text-center', // for <th>
      rowClass: 'text-center', // for <td>
    },
    {
      key: 'name',
      label: 'Nombre',
      sortable: true,
      class: 'max-w-[300px]',
    },
    {
      key: 'image',
      label: 'Imágen',
      class: 'min-w-[150px] max-w-[300px] overflow-x-auto',
    },
    {
      key: 'user.name',
      label: 'Responsable',
      sortable: true,
    },
    {
      key: 'description',
      label: 'Descripción',
      class: 'min-w-[300px]',
    },
    {
      key: 'tags',
      label: 'Etiquetas',
    },
    {
      key: 'files',
      label: 'Archivos',
      class: 'max-w-[300px] overflow-x-auto',
    },
    ...COLUMNS_METADATA,
  ],
}
